import { render, staticRenderFns } from "./UnlockDialog.vue?vue&type=template&id=224baa4f&scoped=true&"
import script from "./UnlockDialog.vue?vue&type=script&lang=js&"
export * from "./UnlockDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224baa4f",
  null
  
)

export default component.exports